import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import '../styles/deposit.css';

function Deposit() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [depositOptions, setDepositOptions] = useState([]);

    // Fetch Admin Accounts from Backend
    useEffect(() => {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        fetch(`${baseUrl}/admin`) // Update with your actual API URL
            .then(response => response.json())
            .then(data => {
                // Assuming API returns an array of admin accounts with crypto fields
                const updatedOptions = [
                    { name: 'BTC (BTCUSD)', icon: <img src="/icons/bitcoin.webp" alt="Bitcoin logo" />, walletAddress: data.find(item => item.type === 'BTC')?.accountNo || 'N/A' },
                    { name: 'Tron (TRC-20)', icon: <img src="/icons/Tron.png" alt="Tron (TRC-20) logo" />, walletAddress: data.find(item => item.type === 'Tron')?.accountNo || 'N/A' },
                    { name: 'Ethereum (ERC20)', icon: <img src="/icons/Ethereum.png" alt="Ethereum logo" />, walletAddress: data.find(item => item.type === 'Eth')?.accountNo || 'N/A' },
                    { name: 'LINE Services', icon: <img src="/icons/line.png" alt="LINE logo" />, walletAddress: data.find(item => item.type === 'LINE')?.accountNo || 'N/A' },
                    { name: 'Binance', icon: <img src="/icons/Binance.png" alt="Binance logo" />, walletAddress: data.find(item => item.type === 'Binance')?.accountNo || 'N/A' },
                    { name: 'OKX', icon: <img src="/icons/OKX.png" alt="OKX logo" />, walletAddress: data.find(item => item.type === 'OKX')?.accountNo || 'N/A' }
                ];
                setDepositOptions(updatedOptions);
            })
            .catch(error => console.error('Error fetching admin accounts:', error));
    }, []);

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedOption(null);
    };

    return (
        <div className="deposit-page">
            <div className="deposit-options">
                {depositOptions.map((option, index) => (
                    <div className="deposit-option" key={index} onClick={() => handleOptionClick(option)}>
                        {option.icon} <span>{option.name}</span>
                    </div>
                ))}
            </div>

            {isModalOpen && selectedOption && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <span className="close" onClick={closeModal}>×</span>
                        <div className="modal-header">
                            <h2>Payment ({selectedOption.name})</h2>
                        </div>
                        <p className="wallet-address">{selectedOption.walletAddress}</p>
                        <QRCodeSVG value={selectedOption.walletAddress} size={250} />
                    </div>
                </div>
            )}
        </div>
    );
}

export default Deposit;
